export default __webpack_public_path__ + "static/media/14.924ae30a.svg";